.adminIndexWrapper {
  margin: 20px;

  & h2 {
    margin-bottom: 12px;
  }
}
